import { render } from "./ProductDataContentRow.vue?vue&type=template&id=69faa370&scoped=true"
import script from "./ProductDataContentRow.vue?vue&type=script&lang=js"
export * from "./ProductDataContentRow.vue?vue&type=script&lang=js"

import "./ProductDataContentRow.vue?vue&type=style&index=0&id=69faa370&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69faa370"]])

export default __exports__